<template>
  <div
    class="confirmation"
    :class="{
      active: opened,
      'confirmation--centered': centered
    }"
  >
    <div class="confirmation__overlay" />
    <div class="confirmation__box d-flex flex-column justify-content-center">
      <div class="confirmation__box__text">
        {{ $t("opravduChceteOdstranit") }}
        <span v-if="items">
          <span v-if="items.length > 1">{{ items.length }}</span>
        </span>
        {{ $t(text ?? "") }}?
      </div>
      <div class="confirmation__box__buttons d-flex align-items-center justify-content-center">
        <button class="btn btn-outline-primary mr-3" @click="$emit('close')">
          {{ $t("zpet") }}
        </button>
        <button class="btn btn-primary d-flex align-items-center justify-content-center" @click="$emit('yes')">
          {{ $t("odstranit") }}
          <!--
          <span v-if="items.length > 1" class="px-1">{{ items.length }}</span>
          {{ $t(text) }}
          -->
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    opened: Boolean,
    items: Array,
    centered: Boolean
  }
}
</script>

<style lang="scss" scoped></style>
